import styled from 'styled-components';
import { Button } from '../SectionButton/SectionButton.styled';

export const MatterportIconWrapper = styled.svg`
  margin-right: 15px;
  margin-top: 5px;
`;

export const FilledCirclePath = styled.path`
  fill: #0877bb;
  display: none;
  opacity: 0;
  transition: all 220ms ease-in-out;

  ${Button}:hover & {
    opacity: 1;
    display: block;
  }
`;
export const CubePath = styled.path`
  fill: #4a90e2;
  transition: all 200ms ease-in-out;

  ${Button}:hover & {
    fill: #ffffff;
  }
`;

export const CirclePath = styled.path`
  fill: #0877bb;
`;
